import { formatDateToString } from '../dateUtils/dateUtils';
import { pushServiceDownError } from '../analytics/datalayer';
import config from '../../temp/config';

const requote = async (quoteData, endpoint, options = {}) => {
  const { agentDetails = {}, utms = {} } = options;

  const hasRecaptcha =
    typeof window !== 'undefined' &&
    config.recaptcha?.toggle &&
    config.recaptcha?.toggle !== 'false';
  let recaptchaToken = '';

  if (hasRecaptcha) {
    await waitForGrecaptcha();
    recaptchaToken = await executeRecaptcha(config.recaptcha.sitekey);
  }

  const today = new Date();
  const todayDdMmYyyy = formatDateToString(today);
  const requestedCoverStartDate = today.toISOString().split('T')[0];

  const updatedQuoteData = {
    ...quoteData,
    prospectDetails: {
      ...quoteData?.prospectDetails,
      coverStartDate: todayDdMmYyyy,
    },
  };

  const requestBody = {
    requestDateTime: today,
    recaptchaToken,
    requestedCoverStartDate,
    agencyCode: agentDetails.salesAgentCode,
    salesChannel: agentDetails.salesChannel,
    ...updatedQuoteData,
    urchinTrackingModule: utms,
  };

  let response;
  try {
    response = await fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: { 'Content-Type': 'application/json' },
    });
  } catch (err) {
    await pushServiceDownError(endpoint, null, err);
    throw err;
  }

  if (!response.ok) {
    await pushServiceDownError(endpoint, response);
    throw new Error(`Requote failed with status ${response.status}`);
  }

  return await response.json();
};

const executeRecaptcha = sitekey => {
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(sitekey, { action: 'submit' }).then(resolve).catch(reject);
    });
  });
};

const waitForGrecaptcha = (timeoutMs = 10000) =>
  new Promise((resolve, reject) => {
    if (window.grecaptcha) {
      return resolve();
    }
    const start = Date.now();
    const id = setInterval(() => {
      if (window.grecaptcha) {
        clearInterval(id);
        resolve();
      } else if (Date.now() - start > timeoutMs) {
        clearInterval(id);
        reject(new Error('grecaptcha failed to load'));
      }
    }, 100);
  });

export default requote;
